import { FontWeight } from '../typography';
export const DEFAULT_BUTTON_DEFINITION = {
  borderRadius: '.3rem',
  fontWeight: FontWeight.MEDIUM
};
//# sourceMappingURL=button.js.map